// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-module--container--2WpL3","footerSection":"footer-module--footerSection--1v9qz","address":"footer-module--address--bVClY"};